import { render, staticRenderFns } from "./channelPopupRussia.vue?vue&type=template&id=3e3f4563&scoped=true"
import script from "./channelPopupRussia.vue?vue&type=script&lang=js"
export * from "./channelPopupRussia.vue?vue&type=script&lang=js"
import style0 from "./channelPopupRussia.vue?vue&type=style&index=0&id=3e3f4563&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f4563",
  null
  
)

export default component.exports